/** Events with an A/B/C priority are races in the calendar and annual plan. */
export function normalizeEventRacePriority(value: unknown): number | null {
  const priority = Number(value);
  return [1, 2, 3].includes(priority) ? priority : null;
}

/** Explicit null clears a former race's priority when editing it into a regular event. */
export function eventRaceFields(isRace: boolean, priority: unknown) {
  return { atp_priority: isRace ? normalizeEventRacePriority(priority) : null };
}
